<template>
	<div class="recharge_prompt shade">
		<div class="prompt-box">
			<div class="header">
				<p class="title">钻石充值</p>
				<p class="text">（首充，充值多少，送多少元ELB）</p>
			</div>
			<div class="content">
				<ul>
					<li v-for="(item,index) in recharge_data" :class="index==isChoosed ? 'checked' : 'unchecked'"  @click="chooseList(index,item.id)">{{item.price}}元充值{{item.amount}}个钻石，送{{item.gifts_elb}}元ELB</li>
					<!--<li :class="0 == isChoosed ? 'checked' : 'unchecked'" @click="choose_package(0)">充值100元，送30元ELB</li>
					<li :class="1 == isChoosed ? 'checked' : 'unchecked'" @click="choose_package(1)">充值200元，送80元ELB</li>
					<li :class="2 == isChoosed ? 'checked' : 'unchecked'" @click="choose_package(2)">充值300元，送150元ELB</li>-->
				</ul>
				<div class="pay_type" v-show="environment">
					<div class="wx" @click="chooseWX()">
						<span class="text" :class="chooseType==0 ? 'checked' : 'unchecked'">微信支付</span>
					</div>
					<div class="alipay" @click="chooseALI()">
						<span class="text" :class="chooseType==1 ? 'checked' : 'unchecked'">支付宝支付</span>
					</div>
				</div>
			</div>
			<div class="footer">
				<div class="cancel" @click="cancelBox">取消</div>
				<div class="sure-btn" @click="sure">确定</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {rechargeParam} from '../assets/js/common.js'
	
	export default{
		props:{
			rechargeInfo:{
				type:Array
			}
		},
		data(){
			return {
				isChoosed:0,
				recharge_data:[],
				conf_id:0,
				pay_type:'',
				chooseType:0
			}
		},
		watch:{
			rechargeInfo:function(){
				this.recharge_data = this.rechargeInfo;
				if(this.recharge_data[0]){
					this.conf_id = this.recharge_data[0].id;
				}
			}
		},
		created(){
//			if(this.environment){
//				this.pay_type = 'WEIXINH5';
//			}
		},
		methods:{
			chooseWX(){
				this.chooseType = 0;
				this.pay_type = 'WEIXINH5';
			},
			chooseALI(){
				this.chooseType = 1;
				this.pay_type = 'ALIPAY';
			},
			cancelBox(){
				this.$emit("colse")
			},
			getList(){
				this.$http.get("/api/v2/recharge/config?"+rechargeParam({
					params:{
						
					}
				},false,true)).then((response) => {
					if(response.data.error == 0){
//						console.log(response.data)
						this.recharge_list = response.data.data;
					}else if(response.data.error == "11002"){
//						this.refreshToken();
						this.$emit("getToken");
					}else{
						alert(response.data.msg);
						
					}
				})
			},
			sure(){
				if(this.environment && this.chooseType == 0){
					this.pay_type = 'WEIXINH5';
				}else if(this.environment && this.chooseType == 1){
					this.pay_type = 'ALIPAY';
				}else{
					this.pay_type = '';
				}
				this.$http.post("/api/v2/recharge/submit?"+rechargeParam({},true,true),{
					conf_id:this.conf_id,
					pay_type:this.pay_type
//					return_url:this.successURL
				},{emulateJSON:true}).then((response) => {
					
//					alert(response.data)
//					if(response.data.error){
//						alert(response.data.msg);
//					}else{
//						document.write(response.data);
//					}
					let urlReg = /^((https|http|ftp|rtsp|mms)?:\/\/)+[A-Za-z0-9]+\.[A-Za-z0-9]+[\/=\?%\-&_~`@[\]\':+!]*([^<>\"\"])*$/;
					let htmlReg = /<[^>]+>/gim;
					if(urlReg.test(response.data)){
						window.location.href = response.data;
					}else if(htmlReg.test(response.data)){
						document.write(response.data);
					}else{
						if(response.data.error > 0){
							alert(response.data.msg);
						}else{
							location.reload();
						}
					}
					
				})
			},
//			refreshToken(){
//				// 刷新token
//				this.$http.get("/api/v2/auth/refresh?"+rechargeParam({
//					params:{
//						token:localStorage.getItem("token")
//					}
//				},false,true)).then((response) => {
//					if(response.data.error == 0){
//						localStorage.setItem("token",response.data.data);
//						alert("刷新token："+localStorage.getItem("token"))
//					}else if(response.data.error == "11002"){
//						
//					}else{
//						alert(response.data.msg);
//						
//					}
//				})
//			},
			chooseList(index,id){
				this.isChoosed = index;
				this.conf_id = id;
//				console.log(this.conf_id)
			}
		}
	}
</script>

<style scoped="scoped">
	/*遮罩层*/
	.shade{ 
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: url(../assets/img/shade-bg@2x.png) no-repeat;
		background-size: 100%;
	}
	.prompt-box{
		position: absolute;
		top: 50%;
		left: 50%;
		margin-left: -3.5rem;
		margin-top: -3.06rem;
		width: 7rem;
		height: 6.12rem;
		background: url(../assets/img/diamond_dialog@2x.png) no-repeat;
		background-size: 100%;
	}
	.header{
		width: 100%;
		height: 1.53rem;
	}
	.header .title{
		padding:0.3rem 0 0.1rem;
		text-align: center;
		font-size:0.48rem;
		font-family:PingFangSC-Medium;
		font-weight:500;
		color:rgba(240,48,73,1);
	}
	.header .text{
		text-align: center;
		font-size:0.2rem;
		font-family:PingFangSC-Medium;
		font-weight:500;
		color:rgba(240,48,73,1);
	}
	.content{
		width: 100%;
		height: 3.16rem;
		/*overflow: scroll;*/
	}
	.content ul{
		margin-top: 0.3rem;
		padding-left: 0.76rem;
		height: 2.1rem;
		overflow: scroll;
	}
	.content li{
		list-style: none;
		margin: 0 0 0.1rem -0.76rem;
		padding-left: 1.6rem;
		width: 7rem;
		height: 0.46rem;
		line-height: 0.46rem;
		/*text-align: center;*/
		font-size:0.22rem;
		font-family:PingFangSC-Regular;
		font-weight:400;
	}
	.content li.checked{
		color:rgba(255,255,255,1);
		background: url(../assets/img/checked_recharge@2x.png) no-repeat 0.76rem center;
		background-size: 5.27rem 0.45rem;
	}
	.content li.unchecked{
		color:rgba(121,121,121,1);
		background: url(../assets/img/unchecked_recharge@2x.png) no-repeat 1.02rem center;
		background-size: 0.3rem;
	}
	.content .pay_type{
		margin-top: 0.46rem;
		display: flex;
		font-size:0.3rem;
		font-family:PingFangSC-Regular;
		font-weight:400;
		color:rgba(78,78,78,1);
	}
	.content .pay_type .text{
		padding-left: 1.24rem;
		padding-right: 0.4rem;
	}
	.content .pay_type .wx{
		flex: 1;
		height: 0.44rem;
		background: url(../assets/img/wx_icon@2x.png) no-repeat 0.64rem center;
		background-size: 0.44rem;
	}
	.content .pay_type .alipay{
		flex: 1;
		height: 0.44rem;
		background: url(../assets/img/alipay_icon@2x.png) no-repeat 0.64rem center;
		background-size: 0.44rem;
	}
	.content .pay_type .text.checked{
		background: url(../assets/img/pay_choosed@2x.png) no-repeat right center;
		background-size: 0.3rem;
	}
	.content .pay_type .text.unchecked{
		background: url(../assets/img/pay_unchoosed@2x.png) no-repeat right center;
		background-size: 0.3rem;
	}
	.footer{
		display: flex;
	}
	.footer .cancel,.footer .sure-btn{
		flex: 1;
		height: 1.12rem;
		line-height: 1.12rem;
		font-size:0.36rem;
		font-family:PingFangSC-Regular;
		font-weight:400;
		text-align: center;
	}
	.footer .cancel{
		color:rgba(51,51,51,1);
	}
	.footer .sure-btn{
		color:rgba(42,137,255,1);
	}
</style>


// WEBPACK FOOTER //
// src/components/recharge_prompt.vue